import { useEffect, useState } from "react";
import { DropdownContainer, Dropdown, Item } from "./dropdown.styles";
export type DropdownItem = {
  label: string | React.ReactNode;
  icon?: any;
  close?: any;
  clickHandler?: () => void;
} | undefined;
type DropdownProps = {
  children: React.ReactNode;
  position?: string;
  items: DropdownItem[];
  deleteAll?: any;
} & React.HTMLAttributes<HTMLDivElement>;
const DropdownMenu = ({
  children,
  position,
  items,
  deleteAll,
  ...otherProps
}: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const openMenu: React.MouseEventHandler<HTMLDivElement> = (e) => {
    e.stopPropagation();
    setIsOpen(true);
  };
  useEffect(() => {
    const closeMenu = () => {
      setIsOpen(false);
    };
    document.addEventListener("click", closeMenu);
    return () => document.removeEventListener("click", closeMenu);
  }, []);

  return (
    <DropdownContainer className="!z-[9999]" onClick={openMenu}>
      {children}
      <Dropdown
        className={`${position ? "!right-0 " + position : ""} ${
          items[0]?.icon &&
          "!min-w-[270px] !max-h-[500px] !overflow-y-auto !z-[9999]"
        }`}
        {...otherProps}
        isOpen={isOpen}
      >
        {items.length > 3 && deleteAll && deleteAll()}
        {items.map((item: any, index: any) => (
          item && <Item
            className={`!z-[9999] ${
              item?.icon && "!flex !justify-center !items-center !gap-1"
            }`}
            key={`item_${index}`}
            onClick={item?.clickHandler}
          >
            {item?.icon && item?.icon}
            {item?.label && item?.label}
            {item?.close && item?.close}
          </Item>
        ))}
      </Dropdown>
    </DropdownContainer>
  );
};
export default DropdownMenu;
